<h2 mat-dialog-title>{{ data.message }}</h2>

<mat-dialog-actions>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onResponse()">Ok</button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onExitResponse()">Exit</button>

</mat-dialog-actions>